
import { Component, Vue, Prop } from 'vue-property-decorator';
import TopNav from '@/app/components/nav/TopNav.vue';
import SideNav from '@/app/components/nav/SideNav.vue';
import OnboardingStatusBanner from '@/app/components/onboarding/OnboardingStatusBanner.vue';
import FeeWarningBanner from '../../banner/FeeWarningBanner.vue';
import AccountStatusBanner from '../../banner/AccountStatusBanner.vue';
import AppUpdaterBanner from '@/app/components/common/AppUpdaterBanner.vue';
import LimitsProfileWarningBanner from 'ah-trades/src/components/warningBanner/LimitsProfileWarningBanner.vue';
import { inheritedMeta } from 'ah-common-lib/src/helpers/router';
import { useAuthStore } from '@/app/store/authModule';
import { onboardingStatuses } from 'ah-api-gateways';

@Component({
  components: {
    TopNav,
    SideNav,
    OnboardingStatusBanner,
    FeeWarningBanner,
    AppUpdaterBanner,
    LimitsProfileWarningBanner,
    AccountStatusBanner,
  },
})
export default class NavViewGrid extends Vue {
  @Prop({ default: false }) hideSidebar!: boolean;

  get authStore() {
    return useAuthStore();
  }

  get isSidebarShown() {
    return !this.hideSidebar && this.authStore.isLoggedIn;
  }

  get hasSidebarView() {
    return !!this.$route.matched.find((r) => !!r.components.sidebar);
  }

  get isFullscreenView() {
    return inheritedMeta(this.$route).fullscreen;
  }

  get isClientInOnboarding() {
    return this.authStore.complianceStatus && onboardingStatuses.includes(this.authStore.complianceStatus);
  }
}
